import ObjectRender from '@common/screens/RenderScreen/ObjectRender';
import { ElementType } from '@common/types/element';
import React from 'react';
import { Dimensions, ScrollView, View } from 'react-native';

type Props = {
  children: any;
  scroll?: {
    active?: boolean;
    arrange?: 'horizontal' | 'vertical';
    showsHorizontalScrollIndicator?: boolean;
  };
  attrs: {
    width: number;
    height: number;
    marginLeft?: number;
    marginTop?: number;
    x?: number;
    y?: number;
  };
  clipContent?: boolean;
  fixedElements?: ElementType[];
};

const GroupScrollableWrapper: React.FC<Props> = (props) => {
  const { width } = Dimensions.get('window');
  const offset = props.attrs.marginLeft;

  const { attrs, scroll, clipContent, fixedElements } = props;
  const topFixedElements =
    fixedElements?.filter((el) => el.fixPosition === 'top') || [];
  const bottomFixedElements =
    fixedElements?.filter((el) => el.fixPosition === 'bottom') || [];

  const renderFixedElements = (
    elements: ElementType[],
    position: 'top' | 'bottom'
  ) => {
    if (!elements.length) return null;
    return (
      <View
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          zIndex: 0,
          backgroundColor: 'transparent',
        }}
      >
        <ObjectRender
          arrComp={elements}
          isScreen={false}
          layout={{
            offsetLeft: attrs.x,
            offsetTop: attrs.y,
            parentWidth: attrs?.width,
          }}
        />
      </View>
    );
  };

  if (clipContent) {
    return (
      <View
        style={{
          width: attrs.width,
          height: attrs.height,
          marginLeft: attrs.x,
          marginTop: attrs.marginTop,
          overflow: 'hidden',
        }}
      >
        {renderFixedElements(topFixedElements, 'top')}
        <ScrollView
          horizontal={scroll?.arrange === 'horizontal'}
          nestedScrollEnabled
          showsHorizontalScrollIndicator={
            scroll?.showsHorizontalScrollIndicator
          }
          style={{
            flex: 1,
            width: Math.min(offset ? width - offset : width, attrs.width),
            paddingBottom: 20,
          }}
        >
          <View>{props.children}</View>
        </ScrollView>
        {renderFixedElements(bottomFixedElements, 'bottom')}
      </View>
    );
  } else if (scroll?.active) {
    return (
      <ScrollView
        horizontal={scroll?.arrange === 'horizontal'}
        nestedScrollEnabled
        showsHorizontalScrollIndicator={scroll?.showsHorizontalScrollIndicator}
        style={{
          minHeight: attrs.height,
          width: Math.min(offset ? width - offset : width, attrs.width),
        }}
      >
        <View>{props.children}</View>
      </ScrollView>
    );
  } else return <>{props.children}</>;
};

export default GroupScrollableWrapper;
